<kt-base-modal [title]="'Device Info'">
    <div modal-body>
        <kt-table #table [rows]="history()" [count]="totalCount()" [options]="tableOptions" [loading]="showLoader()"
            (tableCallback)="tableCallback($event)">
        </kt-table>
    </div>
</kt-base-modal>